<script>
    // Renedrer for ohlcbar + volume (optional)
    // It can be used as the main chart or an indicator

    import VTCandle from './primitives/vt_candle.js'
    import Price from './primitives/vt_price.js'
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'VTCandles',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'Mano', version: '1.0.0',
                    desc: 'VT Candles',
                    preset: {
                        name: 'VTCandles',
                        side: 'onchart',
                        settings: {
                        }
                    }
                }
            },
            init() {
                this.price = new Price(this)
            },
            draw(ctx) {

                //console.log("XCandle.draw() called. this.$props.data.length = " + this.$props.data.length)

                let full_candles = this.$props.layout.full_candles
                let layout = this.$props.layout
                if (full_candles[full_candles.length - 1]) {
                    let cmp = full_candles[full_candles.length - 1].raw[4]
                    for (let i = full_candles.length - 1; i >= 0; i--) {
                        let barData = full_candles[i]
                        new VTCandle(this, ctx, layout, barData, cmp)
                    }
                }

                if (this.price_line) this.price.draw(ctx)
            },
            use_for() { return ['VTCandles'] },

            // When added as offchart overlay
            y_range() {
                return [
                    Math.max(...this.$props.sub.map(x => x[2])),
                    Math.min(...this.$props.sub.map(x => x[3]))
                ]
            }
        },

        // Define internal setting & constants here
        computed: {
            sett() {
                return this.$props.settings
            },
            show_volume() {
                return 'showVolume' in this.sett ?
                    this.sett.showVolume : true
            },
            price_line() {
                return 'priceLine' in this.sett ?
                    this.sett.priceLine : true
            },
            upVolBarColor() {
                return this.sett.upBarColor || "#23a77655"
            },
            downVolBarColor() {
                return this.sett.downBarColor || "#e5415055"
            },
            volBarWidth() {
                return this.sett.barWidth || 1
            },
            upBarColor() {
                return this.sett.upBarColor || "rgb(38, 166, 154)"
            },
            downBarColor() {
                return this.sett.downBarColor || "rgb(239, 83, 80)"
            },
            upBodyColor() {
                return this.sett.upBarColor || "rgb(38, 166, 154)"
            },
            downBodyColor() {
                return this.sett.downBarColor || "rgb(239, 83, 80)"
            },
            blackBarColor() {
                return this.sett.blackBarColor || "#000000"
            },
            barWidth() {
                return this.sett.barWidth || 1
            },
            hlcOnly() {
                return this.sett.hlcOnly || false
            },
            lineWidth() {
                return this.sett.lineWidth || 1
            }
        },
        data() {
            return { price: {} }
        }

    }
</script>
